import '@/styles/globals.css'
import '@/styles/rich-text.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import { MotionConfig } from 'motion/react'
import { Bricolage_Grotesque, DM_Sans, Space_Mono } from 'next/font/google'

const sans = DM_Sans({
    subsets: ['latin']
})

const mono = Space_Mono({
    subsets: ['latin'],
    weight: ['400', '700']
})

// Variable display face: the width and optical size axes are loaded so
// headings can morph with the scroll.
const heading = Bricolage_Grotesque({
    subsets: ['latin'],
    axes: ['opsz', 'wdth']
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:${mono.style.fontFamily};--font-app-heading:${heading.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <MotionConfig reducedMotion='user'>
            <div className='h-full font-sans'>
                <Head>
                    <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
                </Head>

                <Component {...pageProps} />
            </div>
        </MotionConfig>
    )
}

export default App
